//#region IMPORT
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { Button, Dialog } from '../../../../Components/MUIs';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import {
  PersonAdd as PersonAddIcon,
  Close as CloseIcon,
  AccountCircle as AccountCircleIcon,
} from '@mui/icons-material';
import { Box, Paper, TextField, Typography, IconButton } from '@mui/material';
import { getColumnDefs1 } from './SAT_BASIC_05_ColumnDefs';

function SAT_BASIC_05(props) {
  const modalGridRef4 = useRef(); // 교육대상자 선택 팝업 그리드

  const columnDefs = getColumnDefs1(props);
  const searchText = useSelector((state) => state.SearchInfo?.searchText ?? '');

  //#region AuthButton 이벤트
  // 팝업이 열릴 때 그리드의 선택 상태 업데이트

  useEffect(() => {
    if (
      props.modalToggle4 &&
      props.selectedWorkers &&
      props.selectedWorkers.length > 0
    ) {
      const gridApi = modalGridRef4.current?.api;
      if (gridApi) {
        // 그리드가 렌더링된 후 선택 상태 업데이트
        setTimeout(() => {
          const selectedIds = props.selectedWorkers.map((w) => w.id);
          gridApi.forEachNode((node) => {
            if (selectedIds.includes(node.data.id)) {
              node.setSelected(true, false);
            }
          });
        }, 100);
      }
    }
  }, [props.modalToggle4, props.selectedWorkers]);

  useEffect(() => {
    const {
      filterClick5,
      searchClick5,
      addClick5,
      saveClick5,
      printClick5,
      validateSelection,
      setFilterClick5,
      setSearchClick5,
      setAddClick5,
      setSaveClick5,
      setPrintClick5,
      ResetLogicAll,
      SearchLogic1,
      SaveLogic1,
      PrintLogic1,
      setChangedRowData1,
    } = props;

    if (filterClick5) {
      if (!validateSelection()) {
        setFilterClick5(false);
        return;
      }

      props.gridRef.current.api.setQuickFilter(searchText);
      setFilterClick5(false);
    }
    if (searchClick5) {
      ResetLogicAll();
      if (!validateSelection()) {
        setSearchClick5(false);
        return;
      }

      SearchLogic1();
      setSearchClick5(false);
    }
    if (addClick5) {
      if (!validateSelection()) {
        setAddClick5(false);
        return;
      }

      GridFunctions.addClick(props.gridRef, setChangedRowData1);
      setAddClick5(false);
    }
    if (saveClick5) {
      if (!validateSelection()) {
        setSaveClick5(false);
        return;
      }

      SaveLogic1();
      setSaveClick5(false);
    }

    if (printClick5) {
      if (!validateSelection()) {
        setPrintClick5(false);
        return;
      }

      PrintLogic1();
      setPrintClick5(false);
    }
  }, [
    props.filterClick5,
    props.searchClick5,
    props.addClick5,
    props.saveClick5,
    props.deleteClick5,
    props.printClick5,
    searchText,
  ]);

  //#endregion
  return (
    <React.Fragment>
      <BusinessGridCommon
        getRowId={(params) => {
          return params.data.no;
        }}
        deleteYn1={'Y'}
        gridRef={props.gridRef}
        columnDefs={columnDefs}
        rowData={props.rowData1}
        setChangedRowData={props.setChangedRowData1}
        setSelectedRowData={props.setSelectedRowData1}
        flex={1}
        title1="교육이수현황 정보"
        addYn1="Y"
        printYn1="N"
        addClick1={() => {
          if (!props.validateSelection()) return;

          GridFunctions.addClick(props.gridRef, props.setChangedRowData1);
        }}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
        }}
        deleteClick1={(e) => {
          if (!props.validateSelection()) return;

          const newRowExists = props.selectedRowData1.some(
            (row) => row.newYn === 'Y'
          );

          if (!newRowExists) {
            props.MarkedForDeletion1(props.selectedRowData1);
          } else {
            props.NewYnErrorMsg();
          }
        }}
        onCellClicked={(e) => {
          const gridApi = props.gridRef.current.api;
          const clickedRowIndex = e.rowIndex;
          const clickedColumn = e.column?.getColId();

          const isCheckboxClick = e.event?.target?.type === 'checkbox';
          const isEditableCell = e.colDef?.editable === true;

          if (!isCheckboxClick) {
            gridApi.ensureIndexVisible(clickedRowIndex, 'middle');

            // 편집 가능한 셀인 경우 편집 모드로 진입
            if (isEditableCell) {
              const copied = JSON.parse(JSON.stringify(e.data));
              props.handleRowSelection(copied, clickedRowIndex);

              gridApi
                .getDisplayedRowAtIndex(clickedRowIndex)
                ?.setSelected(true, false);

              // 편집 모드로 진입
              gridApi.startEditingCell({
                rowIndex: clickedRowIndex,
                colKey: clickedColumn,
              });
            } else {
              gridApi.setFocusedCell(clickedRowIndex, 'sheGubun');

              const copied = JSON.parse(JSON.stringify(e.data));
              props.handleRowSelection(copied, clickedRowIndex);

              gridApi
                .getDisplayedRowAtIndex(clickedRowIndex)
                ?.setSelected(true, false);
            }
          }
        }}
        onSelectionChanged={() => {
          const gridApi = props.gridRef.current?.api;
          if (!gridApi) return;

          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);

          // selectedRowNosRef 업데이트 (GridCheckBoxFunction과 동기화)
          props.selectedRowNosRef.current = new Set(
            selectedData.map((r) => r.no)
          );

          props.setSelectedRowData1(selectedData);
        }}
      />
      {/* 교육대상자 선택 팝업 */}
      {props.modalToggle4 && (
        <Dialog
          title={null}
          titleSx={{ display: 'none', p: 0, m: 0, height: 0, minHeight: 0 }}
          open={props.modalToggle4}
          onClose={() => {
            props.setSearchKeyword?.('');
            props.setSelectedWorkers?.([]);
            props.setModalToggle4(false);
          }}
          contentSx={{
            p: '0 !important',
            pt: '0 !important',
            pb: '0 !important',
            px: '0 !important',
            py: '0 !important',
            m: '0 !important',
            mt: '0 !important',
            overflow: 'hidden',
            '&.MuiDialogContent-root': {
              padding: '0 !important',
              paddingTop: '0 !important',
            },
          }}
          fullWidth
          maxWidth="lg"
          saveButtonName="확인"
          closeButtonName="취소"
          useSaveButton={true}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => {
            if (!props.currentRowData) return;

            const selectedNames = (props.selectedWorkers || [])
              .map((w) => w.name)
              .filter(Boolean)
              .sort((a, b) => a.localeCompare(b, 'ko')); // 가나다순 정렬

            const targetText =
              selectedNames.length > 0
                ? selectedNames.length === 1
                  ? selectedNames[0]
                  : `${selectedNames[0]} 외 ${selectedNames.length - 1}명`
                : '';

            // 교육대상자 ID 배열 추출
            const targetIds = (props.selectedWorkers || [])
              .map((w) => w.id)
              .filter(Boolean);

            // 그리드 데이터 업데이트
            const { newYn, ...restData } = props.currentRowData;

            // 교육대상자가 비어있으면 newYn을 'Y'로 설정하여 "설정하기" 버튼 표시
            const updatedData = {
              ...restData,
              eduTarget: targetText,
              eduTargetIds: targetIds, // 교육대상자 ID 배열 저장
              sheTargetCount: targetIds.length, // 교육대상자 수 업데이트
              editYn: 'Y',
              // 교육대상자가 비어있으면 newYn을 'Y'로 설정, 있으면 제거
              ...(targetIds.length === 0 ? { newYn: 'Y' } : {}),
            };

            // 그리드 API에서 현재 모든 행 데이터 가져오기
            const gridApi = props.gridRef.current?.api;
            if (gridApi) {
              // 그리드의 모든 행 데이터 가져오기
              const allRowData = [];
              gridApi.forEachNode((node) => {
                if (node.data) {
                  if (node.data.no === props.currentRowData.no) {
                    // 현재 업데이트할 행은 updatedData로 교체
                    allRowData.push(updatedData);
                  } else {
                    // 나머지 행은 그대로 유지
                    allRowData.push(node.data);
                  }
                }
              });

              // rowData1 state 업데이트 (그리드의 모든 행 데이터로 동기화)
              props.setRowData1?.(allRowData);
            } else {
              // 그리드 API가 없을 경우 기존 방식 사용
              props.setRowData1?.((prev) => {
                const updated = prev.map((row) =>
                  row.no === props.currentRowData.no ? updatedData : row
                );
                return updated;
              });
            }

            // changedRowData1에 추가
            props.setChangedRowData1?.((prev) => {
              const filtered = prev.filter(
                (row) => row.no !== props.currentRowData.no
              );
              return [...filtered, updatedData];
            });

            props.setSearchKeyword?.('');
            props.setSelectedWorkers?.([]);
            props.setModalToggle4(false);
          }}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                bgcolor: '#f6f7f8',
                p: 0,
                m: 0,
                mt: 0,
                pt: 0,
                overflow: 'hidden',
              }}
            >
              {/* Top Navigation Bar */}
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #f0f2f4',
                  bgcolor: 'white',
                  px: 3,
                  py: 1,
                  flexShrink: 0,
                  zIndex: 20,
                  m: 0,
                  mt: 0,
                  pt: 1,
                  pb: 1,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: '#111418',
                  }}
                >
                  교육대상자 선택
                </Typography>
                <IconButton
                  onClick={() => {
                    props.setSearchKeyword?.('');
                    props.setSelectedWorkers?.([]);
                    props.setModalToggle4(false);
                  }}
                  sx={{
                    color: '#5f6368',
                    '&:hover': {
                      bgcolor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Paper>

              {/* Main Content */}
              <Box sx={{ display: 'flex', flex: 1, gap: 2, p: 2, overflow: 'hidden' }}>
                {/* 왼쪽: 검색 결과 리스트 */}
                <Paper
                  elevation={0}
                  sx={{
                    flex: 1,
                    p: 2,
                    minWidth: '300px',
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <TextField
                      placeholder="이름 또는 사번으로 검색"
                      variant="outlined"
                      size="small"
                      sx={{ flex: 1 }}
                      value={props.searchKeyword || ''}
                      onChange={(e) => props.setSearchKeyword?.(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          props.SearchLogic4?.();
                        }
                      }}
                    />
                    <Button
                      variant="contained"
                      onClick={() => {
                        props.SearchLogic4?.();
                      }}
                      sx={{
                        minWidth: '80px',
                        bgcolor: '#1976d2',
                        '&:hover': {
                          bgcolor: '#1565c0',
                        },
                      }}
                    >
                      검색
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        const allWorkers = (props.modalRowData4 || []).map(
                          (worker) => ({
                            id: worker.id,
                            name: worker.name || '',
                            position: worker.position || '',
                            depNm: worker.depNm || '',
                            tel: worker.tel || '',
                          })
                        );
                        props.setSelectedWorkers?.(allWorkers);
                      }}
                      sx={{
                        minWidth: '80px',
                        borderColor: '#e0e0e0',
                        color: '#5f6368',
                        '&:hover': {
                          borderColor: '#1976d2',
                          bgcolor: 'rgba(25, 118, 210, 0.04)',
                        },
                      }}
                    >
                      전체선택
                    </Button>
                  </Box>
                <div
                  className="ag-theme-alpine"
                  style={{ height: '550px', width: '100%' }}
                >
                  <BusinessGridCommon
                    gridRef={modalGridRef4}
                    addYn1={'N'}
                    deleteYn1={'N'}
                    refreshYn1={'N'}
                    rowSelection={'none'}
                    setSelectedRowData={() => {}} // 빈 함수로 전달하여 오류 방지
                    setChangedRowData={() => {}} // 빈 함수로 전달하여 오류 방지
                    onSelectionChanged={() => {}} // 빈 함수로 전달하여 내부 로직 우회
                    onCellClicked={(params) => {
                      if (!params || !params.data) return;

                      try {
                        const clickedWorker = {
                          id: params.data.id,
                          name: params.data.name || '',
                          position: params.data.position || '',
                          depNm: params.data.depNm || '',
                          tel: params.data.tel || '',
                        };

                        const currentSelected = props.selectedWorkers || [];
                        const isAlreadySelected = currentSelected.some(
                          (worker) => worker.id === clickedWorker.id
                        );

                        if (isAlreadySelected) {
                          // 이미 선택된 경우 제거
                          const updated = currentSelected.filter(
                            (worker) => worker.id !== clickedWorker.id
                          );
                          props.setSelectedWorkers?.(updated);
                        } else {
                          // 선택되지 않은 경우 추가
                          props.setSelectedWorkers?.([
                            ...currentSelected,
                            clickedWorker,
                          ]);
                        }
                      } catch (error) {
                        console.error('onCellClicked 오류:', error);
                      }
                    }}
                    getRowStyle={(params) => {
                      if (!params || !params.data) return {};
                      const selectedWorkers = props.selectedWorkers || [];
                      const isSelected = selectedWorkers.some(
                        (worker) => worker.id === params.data.id
                      );
                      return {
                        backgroundColor: isSelected ? '#e3f2fd' : 'white',
                        cursor: 'pointer',
                      };
                    }}
                    columnDefs={[
                      {
                        field: 'id',
                        headerName: 'ID',
                        maxWidth: 150,
                      },
                      {
                        field: 'name',
                        headerName: '이름',
                        maxWidth: 150,
                      },
                      {
                        field: 'position',
                        headerName: '직책',
                        maxWidth: 150,
                      },
                      {
                        field: 'depNm',
                        headerName: '소속',
                        maxWidth: 150,
                      },
                      {
                        field: 'tel',
                        headerName: '전화번호',
                        maxWidth: 150,
                      },
                    ]}
                    rowData={(props.modalRowData4 || []).filter((worker) => {
                      const searchKeyword = props.searchKeyword || '';
                      if (!searchKeyword.trim()) return true;
                      const keyword = searchKeyword.toLowerCase();
                      return (
                        worker.name?.toLowerCase().includes(keyword) ||
                        worker.empNo?.toLowerCase().includes(keyword) ||
                        worker.depNm?.toLowerCase().includes(keyword)
                      );
                    })}
                    defaultColDef={{
                      minWidth: 80,
                      resizable: true,
                      sortable: true,
                    }}
                  />
                  </div>
                </Paper>

                {/* 선택된 항목 리스트 */}
                <Paper
                  elevation={0}
                  sx={{
                    width: '400px',
                    p: 2,
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 2,
                      pb: 2,
                      borderBottom: '1px solid #f0f2f4',
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: '#111418',
                      }}
                    >
                      선택된 교육대상자 ({(props.selectedWorkers || []).length}명)
                    </Typography>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        props.setSelectedWorkers?.([]);
                      }}
                      disabled={(props.selectedWorkers || []).length === 0}
                      sx={{
                        borderColor: '#e0e0e0',
                        color: '#5f6368',
                        '&:hover': {
                          borderColor: '#d32f2f',
                          color: '#d32f2f',
                          bgcolor: 'rgba(211, 47, 47, 0.04)',
                        },
                      }}
                    >
                      전체삭제
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      overflow: 'auto',
                      bgcolor: '#f6f7f8',
                      borderRadius: 1,
                      p: 1,
                    }}
                  >
                    {(props.selectedWorkers || []).map((worker, index) => (
                      <Paper
                        key={worker.id || index}
                        elevation={0}
                        sx={{
                          p: 1.5,
                          mb: 1,
                          bgcolor: 'white',
                          border: '1px solid #e0e0e0',
                          borderRadius: 1,
                          position: 'relative',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <AccountCircleIcon
                          sx={{
                            fontSize: 40,
                            color: '#1976d2',
                            mr: 1.5,
                          }}
                        />
                        <Box sx={{ flex: 1 }}>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: 600, color: '#111418' }}
                          >
                            {worker.name}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ color: '#5f6368' }}
                          >
                            {worker.depNm}
                          </Typography>
                        </Box>
                        <IconButton
                          size="small"
                          onClick={() => {
                            const selectedWorkers = props.selectedWorkers || [];
                            props.setSelectedWorkers?.(
                              selectedWorkers.filter((_, i) => i !== index)
                            );
                          }}
                          sx={{
                            color: '#5f6368',
                            '&:hover': {
                              color: '#d32f2f',
                              bgcolor: 'rgba(211, 47, 47, 0.04)',
                            },
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Paper>
                    ))}
                    {(props.selectedWorkers || []).length === 0 && (
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: '100%',
                          textAlign: 'center',
                          py: 4,
                        }}
                      >
                        <PersonAddIcon
                          sx={{
                            fontSize: 48,
                            color: '#9aa0a6',
                            mb: 2,
                          }}
                        />
                        <Typography
                          variant="body1"
                          sx={{ color: '#5f6368', mb: 1 }}
                        >
                          선택한 교육대상자가 없어요
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: '#9aa0a6' }}
                        >
                          선택된 항목을 여기에서 확인하실 수 있어요
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Paper>
              </Box>
            </Box>
          }
        />
      )}
    </React.Fragment>
  );
}

export default SAT_BASIC_05;
